import { useMediaQuery } from '@vueuse/core';

/** The media query for a phone: below 768 pixels wide, Tailwind's `md`. */
export const PHONE_MEDIA_QUERY = '(max-width: 767.98px)';

/**
 * True below 768 pixels wide, Tailwind's `md`. A phone shows peeks as a bottom
 * sheet and has no side peek and no list pane.
 */
export function useIsPhone() {
    return useMediaQuery(PHONE_MEDIA_QUERY);
}

/**
 * The same answer as useIsPhone, read once instead of watched. Use it for a
 * choice that is made when something opens and must not change on a resize.
 */
export function isPhoneScreenNow(): boolean {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
        return false;
    }
    return window.matchMedia(PHONE_MEDIA_QUERY).matches;
}
